'use client';

import classNames from 'classnames';
import React from 'react';
import styles from './ArticleBreadcrumbs.module.scss';

type ArticleBreadcrumbsLink = {
  title: string;
  url?: string;
};

const ArticleBreadcrumbs = ({ items, className }: { items: ArticleBreadcrumbsLink[]; className?: string }) => {
  const removeAsterisks = (text: string) => text.replace(/\*\*(.*?)\*\*/g, '$1');

  return (
    <div className={classNames(styles.breadcrumbs, className)}>
      {items.map((item, index) => {
        const Wrapper = item?.url ? 'a' : 'div';
        const lastItem = (index + 1) === items.length;

        return (
          <React.Fragment key={item.title}>
            <Wrapper
              {...(item?.url ? { href: item.url || '' } : {})}
              className={classNames(styles.breadcrumb, {
                [styles.active]: index === items.length - 1,
                [styles.lastItem]: lastItem,
              })}
            >
              {removeAsterisks(item.title)}
            </Wrapper>
            <svg className={styles.arrowIcon}>
              <use
                href='/media/angle_down.svg#angleDown'
                xlinkHref='/media/angle_down.svg#angleDown'
              />
            </svg>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default ArticleBreadcrumbs;
